import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";

import { LocalLoadingSpinner } from "@/components/Layout/LoadingSpinner/LoadingSpinner";
import { foreground } from "@/styles/colors";

export const TwoFactorChangeAuthQRCode = ({
  qrCodeData,
}: {
  qrCodeData: string | undefined;
}) => {
  const { t } = useTranslation("portal");

  if (!qrCodeData) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <LocalLoadingSpinner />
      </div>
    );
  }

  return (
    <div
      className="flex flex-col items-center rounded-md bg-background-primary p-4"
      role="img"
      aria-label={t("user-account.security.2fa.qrCode.title")}
    >
      <QRCodeCanvas
        value={qrCodeData}
        size={180}
        fgColor={foreground.primary}
      />
    </div>
  );
};
